import { Link } from "react-router-dom";
import { KnotDivider } from "@/components/ornaments";
import { useT } from "@/lib/labels";

export const PageState = ({ loading }) => {
  const t = useT();
  return (
  <div data-testid={loading ? "page-loading" : "page-not-found"} className="max-w-3xl mx-auto px-6 py-32 text-center">
    {loading ? (
      <p className="font-display text-2xl text-[#5e4a35] animate-pulse">Unrolling the scroll…</p>
    ) : (
      <>
        {t("notfound.eyebrow") && <p className="eyebrow">{t("notfound.eyebrow")}</p>}
        {t("notfound.title") && <h1 className="font-display text-4xl sm:text-5xl mt-3">{t("notfound.title")}</h1>}
        <KnotDivider className="my-8" />
        <p className="text-lg italic text-[#5e4a35]">The Lorekeepers have not yet set this tale to vellum.</p>
        {t("notfound.button") && <Link to="/" className="btn-illum theme-flame mt-8">{t("notfound.button")}</Link>}
      </>
    )}
  </div>
  );
};
